import React from "react"
import styled from "styled-components"

const Title = styled.h3`
  color: #233467;
  text-transform: ${props => props.textTransform};
  margin-top: ${props => props.marginTop};
  margin-right: ${props => props.marginRight};
  margin-bottom: ${props => props.marginBottom};
  margin-left: ${props => props.marginLeft};
  text-align: ${props => props.textAlign};
  cursor: ${props => props.cursor};
  font-family: "Bellota Text", cursive;
`

const TitleH3 = (
    {
        content = "",
        marginTop = "30px",
        marginRight = "auto",
        marginBottom = "30px",
        marginLeft = "auto",
        textAlign = "left",
        onClick = null,
        cursor = "auto",
        textTransform = "uppercase",
        children
    }) => {
    return <Title
        marginTop={marginTop}
        marginRight={marginRight}
        marginBottom={marginBottom}
        marginLeft={marginLeft}
        textAlign={textAlign}
        onClick={onClick}
        cursor={cursor}
        textTransform={textTransform}
    >
        {content}
        {children}
    </Title>
}

export default TitleH3
